import { render, staticRenderFns } from "./TableRowBase.vue?vue&type=template&id=32909527&lang=pug&"
import script from "./TableRowBase.vue?vue&type=script&lang=js&"
export * from "./TableRowBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32909527')) {
      api.createRecord('32909527', component.options)
    } else {
      api.reload('32909527', component.options)
    }
    module.hot.accept("./TableRowBase.vue?vue&type=template&id=32909527&lang=pug&", function () {
      api.rerender('32909527', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowBase.vue"
export default component.exports